import { jsx as e, jsxs as t } from "react/jsx-runtime";
import { Dialog as g, DialogBody as u } from "@blueprintjs/core";
import { Button as l } from "@strata/react-buttons";
import C from "nuka-carousel";
import "./main.scss";
const k = ({
  slides: o = void 0,
  isOpen: i = !1,
  onClose: d = void 0,
  usePortal: c = void 0
}) => /* @__PURE__ */ e(
  g,
  {
    isOpen: i,
    canEscapeKeyClose: !1,
    canOutsideClickClose: !1,
    className: "sds_carousel",
    backdropClassName: "sds_carousel__backdrop",
    portalClassName: "sds_dialog__portal-container",
    usePortal: c,
    children: /* @__PURE__ */ e(u, { useOverflowScrollContainer: !1, children: /* @__PURE__ */ e(
      C,
      {
        defaultControlsConfig: {
          pagingDotsContainerClassName: "sds_carousel__paging-dots"
        },
        renderCenterLeftControls: null,
        renderCenterRightControls: null,
        renderBottomLeftControls: ({ previousSlide: s, currentSlide: a }) => a > 0 && /* @__PURE__ */ e(
          l,
          {
            className: "margin__left--small",
            label: "Previous",
            intent: l.Intent.PRIMARY,
            onClick: () => s()
          }
        ),
        renderBottomRightControls: ({ nextSlide: s, currentSlide: a, slideCount: m }) => {
          const r = a === m - 1;
          return /* @__PURE__ */ e(
            l,
            {
              className: "margin__right--small",
              label: r ? "Close" : "Next",
              intent: l.Intent.PRIMARY,
              onClick: (_) => {
                var n;
                return (n = r ? d : s) == null ? void 0 : n(_);
              }
            }
          );
        },
        children: o == null ? void 0 : o.map((s, a) => (
          // eslint-disable-next-line react/no-array-index-key
          /* @__PURE__ */ t("div", { className: "sds_carousel-slide", children: [
            /* @__PURE__ */ e("div", { className: "sds_carousel-slide__image padding__around--x-large", children: /* @__PURE__ */ e("img", { src: s.image, alt: "Carousel", loading: "lazy" }) }),
            /* @__PURE__ */ t("div", { className: "sds_carousel-slide__content padding__around--medium", children: [
              /* @__PURE__ */ e("div", { className: "sds_carousel-slide__content--title padding__around--small", children: s.title }),
              /* @__PURE__ */ e("div", { className: "sds_carousel-slide__content--message padding__top--x-small", children: s.message })
            ] })
          ] }, a)
        ))
      }
    ) })
  }
);
export {
  k as Carousel
};
//# sourceMappingURL=index.js.map
